<!--
 * @Author: xuchen
 * @Date: 2020-03-17 12:42:06
 * @Desc: 回到顶部
 -->

<template>
  <a v-show="showBackTarget" href="javascript:;" class="scroll-top-container" @click="backTop">
    <i class="h-icon-angle_up arrow-icon"></i>
  </a>
</template>

<script>
export default {
  name: 'ScrollToTop',
  props: {
    // 监听的滚动对象
    target: {
      type: String,
      default: ''
    },

    // 显示置顶的高度
    showBackTargetHeight: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      scrollTop: 0, // 滚动高度
      showBackTarget: false // 置顶操作对象
    }
  },
  mounted() {
    document.querySelector(this.target).addEventListener('scroll', this.scrollToTop)
  },
  beforeDestroy() {
    document.querySelector(this.target) &&
      document.querySelector(this.target).removeEventListener('scroll', this.scrollToTop)
  },
  methods: {
    /**
     * @author xuchen
     * @date 2020-03-17 12:43:15
     * @desc 点击图片回到顶部方法，加计时器是为了过渡顺滑
     */
    backTop() {
      const timer = setInterval(() => {
        const ispeed = Math.floor(-this.scrollTop / 5)
        document.querySelector(this.target).scrollTop = this.scrollTop + ispeed
        if (this.scrollTop === 0) {
          clearInterval(timer)
        }
      }, 16)
    },

    /**
     * @author xuchen
     * @date 2020-03-17 12:43:23
     * @desc 为了计算距离顶部的高度，当高度大于1000显示回顶部图标，小于1000则隐藏
     */
    scrollToTop() {
      const scrollTop = document.querySelector(this.target).scrollTop
      this.scrollTop = scrollTop

      if (this.scrollTop > this.showBackTargetHeight) {
        this.showBackTarget = true
      } else {
        this.showBackTarget = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.scroll-top-container {
  position: fixed;
  right: 60px;
  bottom: 80px;
  z-index: 9999;
  width: 44px;
  height: 44px;
  line-height: 44px;
  border: 1px solid #e0e0e0;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.2);
  text-align: center;
  cursor: pointer;
  color: #000;
  background: #fff;
  &:hover {
    opacity: 0.7;
  }
  .arrow-icon {
    line-height: 44px;
    font-size: 20px;
  }
}
</style>
